import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  query getOperator($id: String!) {
    getOperator(id: $id) {
      id
      name
      email
      mobile
      photo
      systemUser {
        username
      }
      error {
        statusCode
        message
      }
    }
  }
`;

const initialState: TYPES.UserState = {
  result: null,
  error: null,
  loading: false
};

export const getOperatorRequest = createAsyncThunk<
  TYPES.User,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(
  'user/get_operator', async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.query({
        query: GRAPHQL,
        variables: params
      });
      return response.data.getOperator;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  });

const getOperatorSlice = createSlice({
  name: 'get_operator',
  initialState: initialState,
  reducers: {
    getOperatorClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(getOperatorRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(getOperatorRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(getOperatorRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { getOperatorClear } = getOperatorSlice.actions;

export const getOperator = createSelector(
  (state: RootState) => state.user.getOperator.result,
  (state: RootState) => state.user.getOperator.error,
  (state: RootState) => state.user.getOperator.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default getOperatorSlice.reducer;